import React, { useEffect, useLayoutEffect, useRef, useState } from 'react';

import './Logos.scss';
import './BrandSettings.scss';
import { useDispatch, useSelector } from 'react-redux';

import { TemplateService } from '../../../services/template-service';
import { container } from 'tsyringe';
import { getOffset, useSharedState } from '../../../utils/helpers';
import { REMOVE_TEMPLATE, SELECT_LOGO, SET_LOGO } from '../../../redux/templates/templateReducer';
import { Template, TemplatePosition, TemplateType } from '../../../models/templateClass';

import Lottie from 'react-lottie-player'
import lottieJson from '../../../assets/lottie/loading_spinner.json';

import * as R from 'ramda';
import { ApiService } from '../../../services/api-service';
import { ClickAwayListener } from '@mui/material';

import DOMPurify from "dompurify";
import { ReactComponent as MenuSvg } from '../../../assets/icons/icon-three-dots.svg';
import ContextualMenu from './ContextualMenu';
import useOnClickOutside from '../../hooks/useOnClickOutside';
import { ActionType, GroupType } from '../../../models/actionClass';
import InlineEdit from '../../utils/InlineEdit';
import NewLabel from '../../newLabel/NewLabel';
import UploadAssetFile from './uploadAssetFile';
import { AssetManagementService } from '../../../services/asset-management-service';
import { MediaType } from '../../../models/mediaClass';
import { SoundKey, SoundService } from '../../../services/sound-service';



const Logos = () => {

  const [apiService] = useState(container.resolve(ApiService));
  const [templateService] = useState(container.resolve(TemplateService));

  const [logos, setLogos] = useSharedState(templateService.logos$);
  const [selectedLogos] = useSharedState(templateService.selectedLogos$);

  const [editingLogo, setEditingLogo] = useState(null);

  const brandSettings = useSelector((state: any) => state.templates.brandsettings);

  const selectedLogosInStore = useSelector((state: any) => state.templates.selectedLogos);

  const dispatch = useDispatch();

  const [selectedFile, setSelectedFile] = useState(null);
  const [isFilePicked, setIsFilePicked] = useState(false);
  const [isFileFailed, setIsFileFailed] = useState(false);
  const [isFileError, setIsFileError] = useState(false);

  const [uploadPercentage, setUploadPercentage] = useState('');

  // assets
  const [assetsService] = useState(container.resolve(AssetManagementService));
  const [uploadAssetKey, setUploadAssetKey] = useSharedState(assetsService.uploadAssetKey$);


  const [showLess, setShowLess] = useState(true);
  const maxLessLength = 6;

  const clearAndUpload = () => {
    setIsFilePicked(false);
    setIsFileFailed(false);
    setIsFileError(false);
    setSelectedFile(null);

    // give time for ADD btn to be redisplayed
    setTimeout(() => {
      const fileAdd = document.getElementById('file-upload-LOGO');
      if (fileAdd) {
        fileAdd.click();
      }
    }, 100);
  }

  const uploadStarted = (file) => {
    setIsFileFailed(false);
    setIsFileError(false);
    setSelectedFile(file);
    setIsFilePicked(true);
  }

  const uploadProgress = (percent) => {
    setUploadPercentage(percent == 0 ? '' : Math.floor(percent) + '%');
  }

  const uploadCompleted = () => {
    setSelectedFile(null);
    setUploadPercentage('100%');
    // setIsFilePicked(false);
  }

  const uploadFailed = () => {
    setIsFileFailed(true);
  }

  const fileError = () => {
    setIsFilePicked(true);
    setIsFileError(true);
    setIsFileFailed(true);
  }

  const editLogo = (logo) => {
    if (!editingLogo) {
      console.log('edit a LT / work on a clone');
      setEditingLogo(R.clone(logo));
    }
  }

  useEffect(() => {
    console.log('logos updated', selectedLogos);

    const updatedLogos = R.clone(logos);
    for (const lg of updatedLogos) {
      lg.selected = false;
      if (selectedLogos.length > 0 && selectedLogos.includes(lg.id)) {
        lg.selected = true;
        lg.isNew = false;
      }
    }
    dispatch({ type: SELECT_LOGO, payload: selectedLogos });
    setLogos(updatedLogos);
    dispatch({ type: SET_LOGO, payload: updatedLogos });

  }, [selectedLogos]);


  let lessFiltered = showLess ? R.clone(logos).slice(0, maxLessLength) : R.clone(logos);

  useEffect(() => {

    if (uploadAssetKey) {
      // check if logos now contains uploadAssetKey
      const media = logos.find(b => b.id === uploadAssetKey);
      if (media) {
        // remove file upload animation
        setIsFilePicked(false);
        setUploadAssetKey(null);
      }
    }

    lessFiltered = showLess ? R.clone(logos).slice(0, maxLessLength) : R.clone(logos);
    console.log('logos updated', logos, lessFiltered);
  }, [logos, showLess]);


  return (
    <div className="Logos">

      <UploadAssetFile mediaType={MediaType.LOGO} accept={'.png, .jpg, .jpeg'} uploadStarted={uploadStarted} uploadProgress={uploadProgress} uploadCompleted={uploadCompleted} uploadFailed={uploadFailed} fileError={fileError}></UploadAssetFile>


      <ul className="logos">
        {isFilePicked &&
          <li key="loading" className="logo">
            <div className="container">
              {!isFileFailed ?
                <>
                  <div className="img" style={{ background: "#f0f0f0" }}>
                    <Lottie loop animationData={lottieJson} play style={{ width: "100%", height: "100%" }} />
                  </div>
                  <div className="percentage">{uploadPercentage}</div>
                  <div className="name">{selectedFile?.name}</div>
                </>
                :
                  isFileError ?
                  <>
                  <div className="img file-error" style={{background: "rgba(255, 51, 121, 0.05)", border: "dashed 1px #e01e5a"}} onClick={() => clearAndUpload()}>
                  </div>
                  </>
                  :
                  <>
                    <div className="img failed-upload" style={{ background: "rgba(255, 51, 121, 0.05)", border: "dashed 1px #e01e5a" }} onClick={() => clearAndUpload()}>
                    </div>
                    <div className="name failed">Failed - click to retry!</div>
                  </>
              }
            </div>
          </li>
        }
        {
          lessFiltered.map(lg => {
            return (<li key={lg.id} id={lg.id} className='logo' >
              <Logo logo={lg} selectedLogosInStore={selectedLogosInStore} editLogo={(lg) => editLogo(lg)}></Logo>
            </li>)
          })
        }
      </ul>
      { isFileError &&
        <div className="explain-error">
          Supported formats: JPEG, PNG. Recommended size 500x500.<br/>
          Max file size: 1MB
        </div>
      }
      {logos.length > maxLessLength ?
        (showLess ?
          <div className="show-action show-less" onClick={() => setShowLess(false)}>Show More</div>
          :
          <div className="show-action show-more" onClick={() => setShowLess(true)}>Show Less</div>
        )
      : <></>
      }
      { logos.length === 0 &&
        <div className="empty">No logo available! Press &ldquo;+&rdquo; to add one.</div>
      }
    </div>
  );
}

interface LogoEditProps {
  logo: Template;
  handleCancel: any;
  handleCreate: any;
}

const LogoEdit = (props: LogoEditProps) => {
  const newLogo = props.logo;

  const [apiService] = useState(container.resolve(ApiService));

  if (!newLogo) {
    return (<></>);
  }

  const setPosition = (event) => {
    const text = DOMPurify.sanitize(event.target.value);

    console.log(text);
    newLogo.position = text;
    apiService.updateReason = { group: GroupType.LOGO, action: ActionType.CHANGE_POSITION, id: newLogo.id, value: text };

  }

  return (
    <div className="logos-editor">
      <div className="card brandsettings">
      </div>
    </div>
  );
}

interface LogoProps {
  logo: Template;
  selectedLogosInStore: string[];
  editLogo: Function;
}
const Logo = (props: LogoProps) => {

  const [soundService] = useState(container.resolve(SoundService));


  const logo = props.logo;
  const selectedLogosInStore = props.selectedLogosInStore;

  const [templateService] = useState(container.resolve(TemplateService));
  const [logos, setLogos] = useSharedState(templateService.logos$);

  const [positionMenuVisible, setPositionMenuVisible] = useState(false);
  const [actionMenuVisible, setActionMenuVisible] = useState(false);

  const apiService: ApiService = container.resolve(ApiService);

  // console.log('logo', logo);


  const [corners, setCorners] = useState([
    { position: TemplatePosition.TOP_RIGHT, available: true },
    { position: TemplatePosition.TOP_LEFT, available: true },
    { position: TemplatePosition.BOTTOM_RIGHT, available: true },
    { position: TemplatePosition.BOTTOM_LEFT, available: true },
  ]);


  const dispatch = useDispatch();

  const contextualMenuRef = useRef(undefined);

  useOnClickOutside(contextualMenuRef, () => {
    setActionMenuVisible(false);
  });


  const [isRenaming, setIsRenaming] = useState(false);

  const [menuCorner, setMenuCorner] = useState({top: 0, left: 0});
  const [menuAction, setMenuAction] = useState({top: 0, left: 0});

  // const IsSelected = (logo) => {
  //   if (!selectedLogosInStore) { return false};
  //   return (selectedLogosInStore.includes(logo.id));
  // }

  const onSelect = (logo) => {
    if (logo.selected) {
      // already selected => hide it
      onHide(logo);
      return;
    }
    const newSelectedLogos = R.clone(selectedLogosInStore);
    newSelectedLogos.push(logo.id);
    dispatch({ type: SELECT_LOGO, payload: newSelectedLogos });

    // compute available corners
    const corners = [
      { position: TemplatePosition.TOP_RIGHT, available: true },
      { position: TemplatePosition.TOP_LEFT, available: true },
      { position: TemplatePosition.BOTTOM_RIGHT, available: true },
      { position: TemplatePosition.BOTTOM_LEFT, available: true },
    ];
    for (const lg of logos) {
      if (lg.selected) {
        const c = corners.find(co => co.position === lg.position && lg.id !== logo.id);
        if (c) {
          c.available = false;
        }
      }
    }

    // check if default logo's position is free
    let selectedPosition = logo.position;
    const corner = corners.find(c => c.position === selectedPosition);
    if (corner && !corner.available) {
      // find first free corner
      const free = corners.find(c => c.available);
      if (free) {
        selectedPosition = free.position;
      }
      // else keep default
    }

    const newLogos = R.clone(logos);
    const newLogo = newLogos.find(l => l.id === logo.id);
    if (newLogo) {
      newLogo.selected = true;
      newLogo.isNew = false;
      newLogo.position = selectedPosition;
    }
    setLogos(newLogos);

    apiService.forceLayerSend = true;
    apiService.updateReason = { group: GroupType.LOGO, action: ActionType.SELECT, id: logo.id, value: logo };

  }

  const onHide = (logo) => {
    if (!logo.selected) {
      return;
    }

    let newSelectedLogos = R.clone(selectedLogosInStore.filter(lid => lid !== logo.id));
    dispatch({ type: SELECT_LOGO, payload: newSelectedLogos });

    const newLogos = R.clone(logos);
    const lg = newLogos.find(l => l.id === logo.id);
    if (lg) {
      lg.selected = false;
      lg.new = false;
    }
    setLogos(newLogos);

    apiService.forceLayerSend = true;
    apiService.updateReason = { group: GroupType.LOGO, action: ActionType.UNSELECT, id: logo.id };
  }

  const openMenuPosition = (ev) => {

    setPositionMenuVisible(!positionMenuVisible);
    let target = ev.target;
    if (ev.target.classList && ev.target.classList[0] === 'change-position') {
      target = target.parentElement;
    }
    const position = getOffset(target);
    let deltaTop = 0;

    const corners = [
      { position: TemplatePosition.TOP_RIGHT, available: true },
      { position: TemplatePosition.TOP_LEFT, available: true },
      { position: TemplatePosition.BOTTOM_RIGHT, available: true },
      { position: TemplatePosition.BOTTOM_LEFT, available: true },
    ];
    for (const lg of logos) {
      if (lg.selected) {
        const c = corners.find(co => co.position === lg.position && lg.id !== logo.id);
        if (c) {
          c.available = false;
          deltaTop += 21;  // menu-item.height + 2* padding + border
        }
      }
    }
    setCorners(corners);

    setMenuCorner({top: position.top - 66 + deltaTop, left: position.left + 46});
  }

  const closeMenuPosition = () => {
    setPositionMenuVisible(false);
  }

  const openMenuAction = (ev) => {
    setActionMenuVisible(!actionMenuVisible);
    const position = getOffset(ev.target);

    setMenuAction({top: position.top - 72, left: position.left - 65});

  }


  const changePosition = (ev, logo, position) => {

    if (ev) {
      ev.stopPropagation();
    }

    const newLogos = R.clone(logos);
    const newlogo = newLogos.find(l => l.id === logo.id);
    if (newlogo) {
      newlogo.position = position;
    }
    setLogos(newLogos);

    apiService.forceLayerSend = true;
    apiService.updateReason = { group: GroupType.LOGO, action: ActionType.CHANGE_POSITION, id: logo.id };

    // fake update store to refresh iFrames
    dispatch({ type: SELECT_LOGO, payload: selectedLogosInStore });

  }
  const focusRename = () => {
    setActionMenuVisible(false);
    setIsRenaming(true);
  }

  const renameLogo = (newName) => {
    setIsRenaming(false);
    console.log('new logo name:', newName);

    setTimeout(() => {
      logo.name = newName;
      logo.isNew = true;
      templateService.save(TemplateType.T_LOGO, logo);
      apiService.updateReason = { group: GroupType.LOGO, action: ActionType.RENAME, value: logo };
      apiService.saveChannel('logos');
    }, 100);

  }

  const deleteLogo = () => {

    // hide this logo from selected list
    onHide(logo);
    setActionMenuVisible(false);

    setTimeout(() => {

      templateService.remove(TemplateType.T_LOGO, logo.id, logo.origin);
      apiService.updateReason = { group: GroupType.LOGO, action: ActionType.REMOVE, id: logo.id };
      dispatch({ type: REMOVE_TEMPLATE, payload: { id: logo.id } });

      dispatch({ type: SELECT_LOGO, payload: selectedLogosInStore });

      soundService.playSoundStart(SoundKey.Trash)
    }, 100);

  }

  const runMenuClose = () => {
    // console.log('scroll runMenuClose');
    setActionMenuVisible(false);
    setPositionMenuVisible(false);
  }

  // Add event listeners
  useLayoutEffect(() => {
    if (actionMenuVisible || positionMenuVisible) {
      // console.log('set scroll listener');
      window.addEventListener("scroll", runMenuClose, true);
    }
    // Remove event listeners on cleanup
    return () => {
      // console.log('remove scroll listener');
      window.removeEventListener("scroll", runMenuClose, true);
    };
  }, [actionMenuVisible, positionMenuVisible])




  return (
    <>
      <div className={"container " + (logo.selected ? "selected" : "")}>

        <div className="img" style={{ backgroundImage: `url(${logo.source})` }}></div>
        {logo.selected ?
          <>
            <div className="action selected" onClick={() => onHide(logo)}></div>
            <div className="tick-selected"></div>
          </>
          :
          <div className="action unselected" onClick={() => onSelect(logo)}></div>
        }


        <div className="button-position" onClick={(ev) => openMenuPosition(ev)}>Position
          <div className={"change-position " + logo.position} ></div>

          {positionMenuVisible &&
            <ClickAwayListener onClickAway={closeMenuPosition}>
              <ul className="menu-position" style={{top: menuCorner.top, left: menuCorner.left}}>
                {
                  (corners.filter(c => c.available)).map(c =>
                    <li key={c.position} className={"menu-item " + c.position + (logo.position === c.position ? ' selected' : ' unselected')} onClick={(e) => changePosition(e, logo, c.position)}></li>
                  )
                }
              </ul>
            </ClickAwayListener>
          }

        </div>

        <div id={'menulogo-' + logo.id} className="button-more" ref={contextualMenuRef}>
          <MenuSvg className="menu-icon" onClick={(ev) => openMenuAction(ev)} />
          {actionMenuVisible &&
            <ContextualMenu onRename={focusRename} onDelete={deleteLogo} style={{ top: menuAction.top, left: menuAction.left }}></ContextualMenu>
          }
        </div>
      </div>
      <div className="name">
        <InlineEdit
          height={18}
          key={logo.name}
          text={logo.name}
          placeHolder="&middot;&middot;&middot;"
          focused={isRenaming}
          onSetText={(text) => renameLogo(text)}
          onDiscard={() => setIsRenaming(false)} />
      </div>

      {logo.isNew &&
        <NewLabel type={'label-logo'}></NewLabel>
      }

    </>
  )
}

export default Logos;